/// <reference path="../../_ext/Editors/MFGLaborGridEditor.ts" />
namespace TabAurous.Production {
    import fld = JobWorkReceiptLaborRow.Fields;

    @Serenity.Decorators.registerClass()
    export class JobWorkReceiptLaborEditor extends _Ext.MFGLaborGridEditor<JobWorkReceiptLaborRow> {
        protected getColumnsKey() { return "Common.CommonLabour"; }

        protected getDialogType() { return JobWorkReceiptLaborDialog; }
        protected getLocalTextPrefix() { return JobWorkReceiptLaborRow.localTextPrefix; }
        protected form: JobWorkReceiptLaborForm;


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as JobWorkReceiptItemsDialog).CalculateTotals();
                }
            });

            this.slickGrid.onRender.subscribe(() => {
                this.SetInlineLookupEditor();
            });

        }

        public setdata(items: JobWorkReceiptLaborRow[]) {
            this.view.setItems([], false);
            for (let Detail of items) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Detail);
            }
        }

        setMasterValues() {
            this.LaborListId = (this.parentDialog as JobWorkReceiptItemsDialog).LaborMarkup;
            this.LaborMarkup = (this.parentDialog as JobWorkReceiptItemsDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as JobWorkReceiptItemsDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as JobWorkReceiptItemsDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as JobWorkReceiptItemsDialog).TransDate;
            this.PartyId = (this.parentDialog as JobWorkReceiptItemsDialog).PartyId;
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);
            return grid;
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var amt = ctx => this.isReadOnly ? TabAurous.ColumnFormatter.ReadOnlyAmountFormatter(ctx, this) : TabAurous.ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.LabourRate).format = amt;
            Q.first(columns, x => x.field === fld.MarkUp).format = amt;

            var CalcOn = Q.first(columns, x => x.field === fld.CalcOnId);
            CalcOn.referencedFields = [fld.CalcOnId];
            CalcOn.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="LCalcId' + ctx.row + '" title="Applicable On" />';
            };

            columns.unshift({
                field: 'Delete Row',
                name: '',
                cssClass: 'btn.btn-app',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        //#region Inline Editor



        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // #endregion
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.ProcessSelectGrid;

            buttons.push({
                title: "Apply Labor Charges",
                cssClass: "add-button",
                onClick: () => {
                    this.setMasterValues();
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        Width: 400,
                        preSelectedKeys: this.view.getItems().map(k => k.ProcessId)
                    });

                    pickerDialog.onSuccess = (selectedLabor: any[]) => {
                        let filteredLabor: any[];
                        filteredLabor = selectedLabor.filter(t => { return !Q.any(this.view.getItems(), n => n.ProcessId == t.ProcessId) });
                        var self = this;
                        var LaborDetails: JobWorkReceiptLaborRow[];

                        let Item = (self.parentDialog as JobWorkReceiptItemsDialog).getItem();
                        LaborDetails = RateHelper.ApplyPurchseLabour(Item, filteredLabor, self.RateListId, self.LaborMarkup, self.TransDate);

                        for (let LaborDetail of LaborDetails) {
                            LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
                            var x = LaborDetail;
                            this.view.addItem(LaborDetail);
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }

}